import { useState } from "react";
import { StarIcon } from "@heroicons/react/24/solid";
import { ExclamationCircleIcon, PaperAirplaneIcon, StarIcon as StarOutline } from "@heroicons/react/24/outline";
import avatar from "../../assets/images/Avatar.avif";
import TextareaField from "../sharedComponents/TextareaField";
import MainButton from "../sharedComponents/MainButton";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import "dayjs/locale/en";
const ReviewsSection = ({ reviews = [], onSubmit, giveReview = false, comments = false }) => {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");
    const { t, i18n } = useTranslation();
    const locale = i18n.language === "ar" ? "ar" : "en";
    const handleSubmit = () => {
        if (!comment.trim()) return;

        const newReview = {
            rating,
            text: comment,
        };

        onSubmit?.(newReview);
        setComment("");
        setRating(0);
    };

    const renderStars = (value, interactive = false) => {
        return [...Array(5)].map((_, index) => {
            const filled = index < value;
            const Icon = filled ? StarIcon : StarOutline;

            return (
                <Icon
                    key={index}
                    onClick={() => interactive && setRating(index + 1)}
                    className={`w-6 h-6 ${filled ? "text-yellow-400" : "dark:text-text-muted-dark text-text-muted-light"
                        } ${interactive ? "cursor-pointer" : ""}`}
                />
            );
        });
    };
    const isDisabled = rating === 0 || !comment.trim();

    // console.log(reviews)
    return (
        <div className="max-w-2xl mx-auto space-y-4 ">
            {/* ADD REVIEW */}
            {giveReview &&
                <div className="p-6 rounded-xl dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    <h3 className="mb-3 text-lg font-semibold dark:text-text-muted-dark text-text-muted-light">
                        {t("reviews.writeReview")}
                    </h3>

                    <div className="flex gap-1 mb-4">{renderStars(rating, true)}</div>

                    <TextareaField
                        placeholder={t("reviews.placeholder")}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                    <p className="mt-4"></p>
                    <MainButton
                        onClick={handleSubmit}
                        disabled={isDisabled}
                    >
                        <span className="flex items-center gap-2 ">
                            <PaperAirplaneIcon className="w-6 h-6 -rotate-45" />
                            {t("reviews.submit")}
                        </span>
                    </MainButton>

                </div>
            }

            {(!reviews || reviews.length === 0) && (
                <div className="flex flex-col items-center justify-center px-4 py-8 space-y-3 text-center rounded-xl dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    <h3 className="text-lg font-semibold text-black dark:text-white">
                        {t("reviews.noReviews")}
                    </h3>

                </div>

            )}
            {/* REVIEWS LIST */}
            {reviews?.map((review, index) => (
                <div
                    key={index}
                    className={`flex justify-between p-5 rounded-xl  ${review?.status === "pending" ? "dark:bg-[#1C2010CC] bg-[#677b2b6b] " : "dark:bg-bg-dark-secondary bg-bg-light-secondary"} `}
                >
                    <div className="flex gap-4">
                        <img
                            src={review?.User?.avatar || avatar}
                            alt="user"
                            className="object-cover w-12 h-12 rounded-full"
                        />

                        <div>
                            <div className="flex items-center gap-2">
                                <h4 className="font-semibold text-black dark:text-white">
                                    {review?.User?.fullName}
                                </h4>
                                <span className="text-xs dark:text-text-muted-dark text-text-muted-light">
                                    {dayjs(review?.createdAt).locale(locale).fromNow()}
                                </span>
                            </div>

                            {comments &&
                                <div className="flex gap-1 mt-1">
                                    {renderStars(review?.rating)}
                                </div>
                            }

                            <p className="mt-2 text-sm text-black dark:text-white">
                                {review?.text}
                            </p>
                        </div>
                    </div>

                    {review?.status === "pending" && (
                        <div className="flex items-center gap-2 px-3 py-2 text-sm text-yellow-600 border border-yellow-600 dark:border-yellow-400 dark:text-yellow-400 h-fit rounded-xl lg:text-lg">
                            <ExclamationCircleIcon className="w-6 h-6" />
                            {t("reviews.underReview")}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default ReviewsSection;
